export interface Composition {
  id: number;
  title: string;
  created: string;
  parent_id?: number;
  child_id?: number;
  status:
    | 'writing'
    | 'finished'
    | 'automatic review running'
    | 'manual review pending'
    | 'teacher revision pending'
    | 'reviewed'
    | 'preparing';
  composition_raw: string;
  finished?: string;
  flag_finished: boolean;
  child_id_status: string;
  learning_path_user_instance_id: number;
  step_id: number;
  modified?: string;
  review_type: string;
  test: Test;
  user_name: string;
  instruction_id: number;
  review_grid: number;
}

interface Test {
  id: number;
  start_datetime: string; // ISO string
  end_datetime: string;
  name: string;
  theme_name: string;
  timer: number | null;
  test_type: string;
  uses_ai_comp: boolean;
  template_name: string | null;
  editor: string;
  uses_write_preparation: boolean;
  template_result: string | null;
  is_required?: boolean;
}

export interface CompositionToSave {
  title: string;
  id: number | string;
  review_type: string;
  uses_ai_comp: boolean;
  composition_raw: string;
  composition_source: string;
}

export const SaveCompositionErrors: Record<
  string,
  {name: string; description: string}
> = {
  "This composition can't even more be changed because the test is already expired!":
    {
      name: 'Não é Mais Possível Editar',
      description:
        'O tempo para editar esta redação acabou. Agora é só aguardar a correção!',
    },
  'Composition is not the current step in learning path.': {
    name: 'A etapa anterior não foi concluída',
    description:
      'Você pode ter um questionário e/ou escrita que não foi finalizado. Se você tiver um questionário, verifique e garanta que passou e respondeu todas as questões. Se você tiver uma escrita nessa atividade, garanta que o texto foi enviado',
  },
  'Trying to modify finished composition': {
    name: 'Redação Finalizada!',
    description:
      'Você já concluiu e enviou esta redação. Não é possível fazer alterações depois do envio.',
  },

  'Network Error': {
    name: 'Lembre-se:',
    description:
      'você concluiu esse passo sem conexão com a internet. É necessário ficar online antes do prazo de terminar!',
  },
};

export interface CompositionDetails {
  test_id?: number;
  instruction_id_id?: number;
  step_id?: number;
}
